(function()
{
    //Import classes

    var BasePanel = include('WGBH.UIPanel'),
		Text=include("WGBH.PIXIText"),
		
		Sprite = include('PIXI.Sprite'),
		Graphics = include('PIXI.Graphics'),
		Button=include("springroll.pixi.Button"),
		Container=include("PIXI.Container"),
		Point=include("PIXI.Point"),
		Texture = include('PIXI.Texture'),
		EventDispatcher=include('springroll.EventDispatcher');
    /**
     * Panel contains all of the visual elements for the game state
     * @class WGBH.GamePanel
     * @extends PIXI.Container
     */
    var GamePanel = function()
    {
        BasePanel.call(this);
		this.items={}; // addressable items		
    };



    //Extend the base panel
    var p = extend(GamePanel, BasePanel);

	
	
    /**
     * Setup the state, this happens on each state entering
     */
    p.setup = function()
    {		

		this.background1=new Sprite.fromImage(imageurls.bg_zoo);
		this.background1.interactive=true;
		this.background1.on(app.click,this.clickbackground);
		this.background2=new Sprite.fromImage(imageurls.bg_snow);
		this.background2.interactive=true;
		this.background2.on(app.click,this.clickbackground);
		this.background3=new Sprite.fromImage(imageurls.bg_blueprint);
		this.background3.interactive=true;
		this.background3.on(app.click,this.clickbackground);
		
		this.addChild(this.background1);
		this.addChild(this.background2);
		this.addChild(this.background3);
		this.background2.visible=false;

		this.interactive=true;

    };

	p.indexpane=function(showcreate) {
		this.hidegamestuff();		
		this.hideitem("createindex");
		// reset the size of the play/create buttons
		this.playbutton.scale.x=this.playbutton.scale.y=1;
		this.createbutton.scale.x=this.createbutton.scale.y=1;
		this.background1.visible=true;
		this.background2.visible=false;
		this.background3.visible=false;
		this.items.index.visible=true;
		if(!showcreate) {
			this.createbutton.alpha=0.5;
		} else {
			this.createbutton.alpha=1;
		}
	};
	
	p.hideindex=function() {
		this.items.index.visible=false;
	};
	
	p.hidegamestuff=function() {
		this.showgamestuff(false);
	};
	
	p.showgamestuff=function() {
		this.background2.visible=true;
		this.background3.visible=false;
		this.background1.visible=false;
	};
	p.editmode=function(yesorno) {
		if(yesorno) {
			this.background2.visible=false;
			this.background3.visible=true;
			this.background1.visible=false;
		} else {
			this.background2.visible=true;
			this.background3.visible=false;
			this.background1.visible=false;
		}
	};


    /**
     * Un-setup the panel when exiting the state
     */
    p.teardown = function()
    {
    	// remove the children and stop the button events
    	this.uiteardown();

		this.background1.off(app.click,this.clickbackground);
		this.background2.off(app.click,this.clickbackground);
		this.background3.off(app.click,this.clickbackground);
    };

    
    p.addvis=function(visual) {
    	this.addChild(visual);
    };
    
    
    p.removeitemmain=function(item) {
    	for(var ch in this.children) {
    		if(item==this.children[ch]) {
    			this.children.splice(ch,1);
    			return;
    		}
    	}
    };
    
    p.showitem=function(itemid,orhide) {
    	var founditem=this.items[itemid];
    	if(!founditem) return;
    	if(orhide===false) {
    		founditem.visible=false;
    		if(founditem.interactive) {
    		founditem.wasinteractive=true;
    		founditem.interactive=false;}
    	} else {
    		founditem.visible=true;
    		if(founditem.wasinteractive) {
    			founditem.interactive=true;
    		}
    	}
    };
    
    p.hideitem=function(itemid) {
    	this.showitem(itemid,false);
    };
    
    //Assign to namespace
    namespace('WGBH').GamePanel = GamePanel;
}());